export default class SignUpComponent {
    constructor() {
        return {
            template: '<div>SignUp</div>',
            controller: SignUpComponentCtrl,
            controllerAs: 'signUp'
        }
    }
}

class SignUpComponentCtrl {
    constructor($rootScope) {

        this._rootScope = $rootScope;
        this._rootScope.$broadcast('event:signUp.show');

        this.$onDestroy = () => {
            this._rootScope.$broadcast('event:signUp.hide');
        }
    }
}

SignUpComponentCtrl.$inject = ['$rootScope'];
